import { createStore } from "vuex";

import { autenticacao } from "../modules/autenticacao/autenticacaoStore";
import { unidade } from "../modules/unidade/unidadeStore";
import { funcionario } from "../modules/funcionario/funcionarioStore";
import { emitir } from "../modules/permissao/emitirStore";
import { centroCusto } from "../modules/centroCusto/centroCustoStore";
import { funcoes } from "../modules/funcoes/funcoesStore";
import { pdt } from "../modules/permissaoDeTrabalho/store";
import { office } from "../modules/backOffice/store";
import { cse } from "../modules/controleEmocional/store";
import { org } from "../modules/organizacional/store";
import { area } from "../modules/organizacional/area/areaStore";
import { ter } from "../modules/terceiros/store";
import { fer } from "../modules/ferramentasAdm/store";
import { requisicao } from "../modules/requisicao/store";
import { rel } from "../modules/relatorios/store";
import { ctd } from "../modules/centralDownloads/store";
import { termo } from "../modules/termosDeUso/store";
import { biometria } from "../modules/biometria/store";
import { user } from "../modules/legado/usuarios/store";
import { notificacao } from "../modules/alertas/store";
import { produtos } from "../modules/produtos/store";
import { catalogo } from "../modules/legado/catalogo/store";
import { seguranca } from "../modules/seguranca/store";
import { centroDeCusto } from "../modules/centroDeCusto/store";
import { perfis } from "../modules/perfis/store";
import { configuracao } from "../modules/configuracao/store";
import { integracao } from "../modules/legado/integracao/store";
import { grupoProdutos } from "../modules/legado/grupoProdutos/store";
import { notaFiscal } from "../modules/legado/notaFiscal/store";
import { treinamento } from "../modules/legado/treinamento/store";
import { processos } from "../modules/legado/processos/store";
import { ordem } from "../modules/legado/ordem/store";
import { maquina } from "../modules/legado/maquina/store";
import { ajusteEstoque } from "../modules/legado/ajusteEstoque/store";
import { adminPostos } from "../modules/legado/adminPostos/store";
import { adminMultpex } from "../modules/legado/adminMultpex/store";
import { estoque } from "../modules/legado/estoque/store";
import { transferencia } from "../modules/legado/transferencia/store";
import { inventario } from "../modules/legado/Inventario/store";
import { compras } from "../modules/legado/compras/store";
import { documento } from "../modules/documentos/store";
import { ferramentaria } from "../modules/ferramentaria/store";
import { ind } from "../modules/indicadores/store";
import { pkg } from "../modules/picking/store";
import { wf } from "../modules/legado/catalogoWF/store";
import { facialStore } from "../modules/facial/store";
import { simplificadoStore } from "../modules/simplificado/store";
import { comprasSolicitante } from "../modules/legado/comprasSolicitante/store";
import { produtosNovo } from "../modules/produtosNovo/store";
import { usuarioNovo } from "../modules/usuariosTeste/store";
import { fiscalStore } from "../modules/legado/fiscal/store";
import { refactorTablet } from "../modules/refactorTablet/store";
import { gdcStore } from "../modules/gestaoDeContrato/store";

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    autenticacao,
    funcionario,
    emitir,
    unidade,
    centroCusto,
    funcoes,
    pdt,
    cse,
    org,
    area,
    ter,
    fer,
    office,
    requisicao,
    rel,
    ctd,
    termo,
    biometria,
    user,
    notificacao,
    produtos,
    catalogo,
    seguranca,
    centroDeCusto,
    perfis,
    configuracao,
    integracao,
    grupoProdutos,
    notaFiscal,
    treinamento,
    processos,
    ordem,
    maquina,
    ajusteEstoque,
    adminPostos,
    adminMultpex,
    estoque,
    transferencia,
    inventario,
    compras,
    documento,
    ferramentaria,
    ind,
    pkg,
    wf,
    facialStore,
    simplificadoStore,
    comprasSolicitante,
    produtosNovo,
    usuarioNovo,
    fiscalStore,
    refactorTablet,
    gdcStore,
  },
});
